<template>
  <v-card class="elevation-12" :loading="loading">
    <v-toolbar
        color="primary"
        dark
        flat
    >
      <v-toolbar-title>{{ $t('addRegistryPermissionForm.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-autocomplete v-model="registryPermission.organization"
                        :items="organizations"
                        :label="$t('addRegistryPermissionForm.label')"
                        :dense="true"
                        :clearable="true"
                        class="py-5"
                        item-text="name"
                        item-value="id"
                        style="margin: 20px 10px 0 10px"
        />

        <v-snackbar v-model="isServerError"
                    :timeout="5000"
                    :top="true"
                    color="error"
        >
          {{ $t('addRegistryPermissionForm.messages.serverError') }}
        </v-snackbar>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="secondary" @click="onCancelButtonClicked">{{ $t('addRegistryPermissionForm.actions.cancel') }}</v-btn>
      <v-spacer/>
      <v-btn text color="primary" @click="onAddButtonClicked">{{ $t('addRegistryPermissionForm.actions.add') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import _ from "underscore";
import Mappers from "@/mappers";
import OrganizationService from "@/services/organization.service";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import AdminRegistyPermissionService from "@/services/admin.registy.permission.service";

export default {
  name: "AddAdminRegistryPermissionComponent",
  data() {
    return {
      loading: false,
      registryPermission: {
        organization: null
      },
      organizations: [],
      isServerError: false,
    }
  },
  computed: {
    organizationErrors() {
      const errors = []

      if (this.$v.template.organization.$dirty)
        if (!this.$v.template.organization.required)
          errors.push(this.$t('addRegistryPermissionForm.error'))

      return errors
    },
  },
  validations: {
    template: {
      organization: {
        required
      },
    }
  },
  methods: {
    init() {
      this.clear()
      this.loadOrganizations()
    },

    clear() {
      this.$v.$reset()
      this.registryPermission.organization = null
    },
    loadOrganizations() {
      this.$store.dispatch(LAYOUT_LOADING_START)

      OrganizationService.getOrganizations({})
          .then(response => {
            this.organizations = _.map(response.data.Records, o => {
              return Mappers.mapOrganization(o?.Organization)
            })
          })
          .finally(() => {
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onCancelButtonClicked() {
      this.clear()
      this.$emit('cancel')
    },
    onAddButtonClicked() {
      if (this.registryPermission.organization !== null) {
        this.loading = true;
        this.$store.dispatch(LAYOUT_LOADING_START)

        this.isServerError = false
        var organizationId = this.registryPermission.organization

        AdminRegistyPermissionService.post({organizationId})
            .then(() => {
              this.clear()
              this.$emit('added')
            }, () => {
              this.isServerError = true
            })
            .finally(() => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    }
  }
}
</script>

<style scoped>

</style>